<template>
  <BaseBox>
    <base-form ref="form">
      <email-input ref="email" v-model="email" />
      <name-input ref="name" v-model="name" />
      <username-input ref="username" v-model="username" />
      <StoreAliasInput ref="StoreAliasInput" v-model="alias" />
      <telephone-input ref="phone" v-model="phone" />
      <cellphone-input ref="cellphone" v-model="cellphone" />
      <password-input ref="password" v-model="password" />
      <code-input ref="code" v-model="code" label="via sms" />
      <birthday-input ref="birthday" v-model="birthday" />
      <br />
      <br />
      <br />
      <br />
      <DoublePwInput ref="dbPassword" v-model="dbPassword" />
    </base-form>
    <br />
    <BaseButton @click="validateForm()">Enviar</BaseButton>
  </BaseBox>
</template>

<script>
import BaseBox from "@/components/Box";
import BaseButton from "@/components/Button";
import BaseMessage from "@/components/Message";
import EmailInput from "./EmailInput.vue";
import NameInput from "./NameInput.vue";
import TelephoneInput from "./TelephoneInput.vue";
import CellphoneInput from "./CellphoneInput.vue";
import UsernameInput from "./UsernameInput.vue";
import StoreAliasInput from "./StoreAliasInput.vue";
import PasswordInput from "./PasswordInput.vue";
import CodeInput from "./ConfirmCodeInput.vue";
import DoublePwInput from "./DoublePwInput.vue";
import BirthdayInput from "./BirthdayInput.vue";
import BaseForm from "@/containers/Form.vue";

export default {
  data() {
    return {
      email: null,
      name: "",
      username: null,
      alias: null,
      phone: "",
      code: "",
      birthday: "",
      cellphone: "",
      password: "",
      dbPassword: {
        password: "",
        confirmPassword: "",
      },
    };
  },
  methods: {
    validateForm() {
      this.$refs.form.validateInputs();
      if (!this.$refs.form.messages.length) {
        alert("Dados validados com sucesso!");
      }
    },
  },
  components: {
    EmailInput,
    NameInput,
    TelephoneInput,
    CellphoneInput,
    PasswordInput,
    DoublePwInput,
    BaseBox,
    BaseForm,
    BaseButton,
    BaseMessage,
    UsernameInput,
    StoreAliasInput,
    CodeInput,
    BirthdayInput,
  },
};
</script>